import React from "react";

const features = [
  "Premium quality ingredients",
  "Authentic flavors",
  "Rigorous quality control",
  "Sustainable practices",
];

const QualityCard = () => (
  <div className="bg-white rounded-xl shadow-md p-8 max-w-md mx-auto">
    <ul className="space-y-4 mb-6">
      {features.map((feature, idx) => (
        <li key={idx} className="flex items-center text-gray-700">
          <span className="text-green-500 mr-3">
            {/* Checkmark SVG */}
            <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" className="inline-block align-middle">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </span>
          <span>{feature}</span>
        </li>
      ))}
    </ul>
    <hr className="my-4" />
    <div className="text-center mt-4">
      <span className="italic text-orange-500 font-semibold text-lg">
        "Where flavor meets integrity"
      </span>
    </div>
  </div>
);

export default QualityCard; 